import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeContractorExportOrderBetweenOffice extends BaseCommand {
  CommandName = "ChangeContractorExportOrderBetweenOffice";
  Command: {
    ExportOrderBetweenOffice: boolean;
  };
  constructor(sessionId: string, operationId: string, exportOrderBetweenOffice: boolean) {
    super(sessionId, operationId);
    this.Command = { ExportOrderBetweenOffice: exportOrderBetweenOffice };
  }
}
